const SectionType = Object.freeze({
  Strengths: 1,
  Needs: 2,
  Goals: 3,
  CriteriaAndProcedures: 4,
  Specialist: 5,
  AchievementsSummary: 6,
});

export default SectionType;
